export const ratings = {
    0: "Skip It",
    1: "Okay",
    2: "Try It",
    3: "Must Try"
};
